module.exports = __webpack_public_path__ + "static/img/vant.2e036e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vant.png
// module id = kVTJ
// module chunks = 0